module.exports = __webpack_public_path__ + "static/img/img-aboutus-01.9adb19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-aboutus-01.png
// module id = Ktwl
// module chunks = 1